import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'app/services/auth.service';
import { EmailSubdomainGuard } from 'app/services/email-subdomain.guard';
import { environment } from 'environments/environment';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'edit-profile-dialog',
  templateUrl: './edit-profile-dialog.component.html',
  styleUrls: ['./edit-profile-dialog.component.css']
})
export class EditProfileDialogComponent implements OnInit {
  firstName: string;
  lastName: string;
  rank: string;
  email: string;
  profilePicture: any;
  profilePictureRequest;
  invalidPicture = false;
  unapprovedEmail = false;
  approvedEmailsRegex = new RegExp('[^\s@]+@(aptima.com)');
  approvedEmailDomains = '';

  @ViewChild('newImage', { static: true }) newImageInput;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditProfileDialogComponent>,
    private guardHelper: EmailSubdomainGuard,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.firstName = this.data.firstName;
    this.lastName = this.data.lastName;
    this.rank = this.data.rank;
    this.email = '' + this.data.email;
    this.profilePicture = this.data.profilePicture;

    this.unapprovedEmail = !this.guardHelper.isEmailApproved(this.email);
    this.authService.getApprovedDomains().subscribe(() => {
      this.approvedEmailsRegex = new RegExp('[^\\s@]+@(' + this.authService.approvedEmailDomains.join('|') + ')');
      this.approvedEmailDomains = this.authService.approvedEmailDomains.map(x => (`@${x}`)).join(', ');
    });
  }

  save() {
    const result = {
      firstname: this.firstName,
      lastname: this.lastName,
      rank: this.rank ? this.rank : '',
      email: this.data.email === this.email ? undefined : this.email
    };

    if (this.profilePictureRequest) {
      result['profilePicture'] = {
        requestData: this.profilePictureRequest,
        imageDataUrl: this.profilePicture
      };
    }

    this.dialogRef.close(result);
  }

  readUrl(event) {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type !== 'image/jpg' &&
        event.target.files[0].type !== 'image/png' &&
        event.target.files[0].type !== 'image/jpeg') {
        this.dialog.open(AlertDialogComponent, {
          data: {
            title: 'Invalid Format',
            content: 'The image must be of file type .jpg, .jpeg, or .png.'
          }
        });
      } else {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.profilePicture = this.sanitizer.bypassSecurityTrustUrl(e.target.result);
        };

        reader.readAsDataURL(event.target.files[0]);

        this.profilePictureRequest = event.target.files[0];
      }
    }
  }

  getRequestLink() {
    return environment.applySubstitutions(environment.request_account_url);
  }
}
